import "./sentryTools"; // Sentry initialization should be imported first!
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { store, persistor } from 'root/store';
import IntlProviderWrapper from 'i18n/IntlProviderWrapper';
import { isHostedOnProductionURL } from 'myParkdUtils/utils';
import TagManager from 'react-gtm-module';
import { setDefaultGtmConsent } from 'myParkdUtils/googleAnalytics';

//import { StrictMode } from 'react';
// todo: prepare to enable StrictMode

if (isHostedOnProductionURL()) {
    setDefaultGtmConsent();
    TagManager.initialize({
        gtmId: 'GTM-KDHKCH9H'
    });
}

const rootEl = document.getElementById('root');
const root = createRoot(rootEl!);

root.render(
    //<StrictMode>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <IntlProviderWrapper />
        </PersistGate>
    </Provider>
    //</StrictMode>
);

// To compare caching
console.info({
    VITE_RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION,
    VITE_RELEASE_DATE: import.meta.env.VITE_RELEASE_DATE,
    VITE_BITBUCKET_BUILD_NUMBER: import.meta.env.VITE_BITBUCKET_BUILD_NUMBER,
});
